import React from 'react';
import { Switch, Route, Redirect, Router } from 'react-router-dom';
import { Layout } from 'antd/lib';

import history from '../routes/history.js';

import 'antd/dist/antd.css';
import 'antd/lib/layout/style';
import 'antd/lib/icon/style';
import 'antd/lib/breadcrumb/style';
import 'antd/lib/menu/style';
import '../assets/main.css';

const { Content, Footer } = Layout;

import ErrorBoundary from './common/ErrorBoundary.js';
import FormVerificacionAutorizacionContainer from './public/verificacionMenor/ViajeMenoresPublicContainer.js'
import FormVerificacionAutorizacionTrabajoMenor from './public/verificacionTrabajoMenor/TrabajoMenoresPublicContainer.js'
import Login from './public/Login.js'

class AppPublic extends React.PureComponent {
  render() {
      const currentPath = window.location.pathname;
      const isPublicPath = ['/viajeMenor', '/trabajoMenor', '/documentos/public']
      .some(path => currentPath.startsWith(path));

    const { authenticator } = this.props;
    console.log("---Vine por app publico")
    return (
      <ErrorBoundary>
        <Router history={history}>
          <Layout>
            <Layout style={{ background: '#fff' }}>
              <div className="wrapper d-flex flex-column">
                <main className="flex-fill">
                  <Content style={{ padding: '64px 50px' }}>
                    <div
                      style={{ background: '#fff', padding: 5, minHeight: 280 }}
                    >
                      <Switch>
                        <Route
                          exact
                          path="/viajeMenor"
                          render={() => <FormVerificacionAutorizacionContainer />}
                        />

                        <Route
                          path="/viajeMenor/:codigo"
                          render={(props) => <FormVerificacionAutorizacionContainer {...props} />}
                        />
                        <Route
                          exact
                          path="/trabajoMenor"
                          render={() => <FormVerificacionAutorizacionTrabajoMenor />}
                        />

                        <Route
                          path="/trabajoMenor/:codigo"
                          render={(props) => <FormVerificacionAutorizacionTrabajoMenor {...props} />}
                        />

                        <Route exact path="/login" 
                          render={(props) => <Login key={Date.now()} {...props} />}
                          //  component={Login} 
                        />

                        <Route render={() => {
                            // If already on a public path, just return null to prevent redirect
                            if (isPublicPath) {
                              console.log("---AppPublic Already on public path, not redirecting");
                              // Return the appropriate component based on path
                              if (currentPath.startsWith('/viajeMenor')) {
                                const pathParts = currentPath.split('/');
                                const codigo = pathParts.length > 2 ? pathParts[2] : null;

                                return codigo ? 
                                  <FormVerificacionAutorizacionContainer codigo={codigo} /> : 
                                  <FormVerificacionAutorizacionContainer />;
                                }
                              
                              // Add more conditions for other public paths

                              // Fallback
                              return <div>Página pública</div>;
                            }

                            // Otherwise redirect to login
                            console.log("---AppPublic Not a public path, redirecting to login");
                            return <Redirect to="/login" />;
                          }} />

                      </Switch>
                    </div>
                  </Content>
                </main>
                <Footer className="footerGeneral" id="footer-pj">
                  Direccion General de Informatica ©2025
                </Footer>
              </div>
            </Layout>
          </Layout>
        </Router>
      </ErrorBoundary>
    );
  }
}

AppPublic.propTypes = {};

export default AppPublic;
